import { useApi } from '../api'
import types from '../apiTypes'
import useUser from './useUser'
import { UserPreferences } from '../../types'

function useUserPreferences(): UserPreferences | null {
  const user = useUser()
  const [preferences] = useApi(types.USER_PREFERENCE, {
    query: {
      id: user.id,
    },
  })

  return preferences.value
}

export default useUserPreferences
